<script lang="ts">
	import Poll from './Poll.svelte';
</script>

<style>
	.known {
		display: flex;
		justify-content: space-between;
	}
	.col {
		width: 15rem;
	}
	.known p {
		margin-bottom: 0;
	}
	.known ul {
		margin: 1rem 0;
		padding-left: 1.2rem;
	}
	.known li {
		margin: 0 0 0.5rem 0;
	}
	@media only screen and (max-width: 600px) {
		.known {
			flex-direction: column;
			align-items: flex-start;
			padding: 0;
		}
	}
</style>

<p>ok so here's the deal:</p>
<div class="known">
  <div class="col">
    <p>what is known</p>
    <ul>
      <li>it will be a virtual dumbathon</li>
      <li>there will be minecraft</li>
    </ul>
  </div>
  <div class="col">
    <p>what is not known</p>
    <ul>
      <li>when it's gonna happen</li>
      <li>panic sell? 📉</li>
    </ul>
  </div>
</div>
<p>pick some weekends below that work for you. this isn't a commitment but rather just a rough idea of when we can do it</p>
<p>oh and you can update your choices whenever you please</p>
<Poll />